import { createActionGroup } from '@ngrx/store';

export const SocietePatrimoineHierarchieAncetreActions = createActionGroup({
  source: 'Societe Patrimoine Hierarchie Ancetre',
  events: {}
});
